var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module windy
 */
import BaseImageLayer from 'ol/layer/BaseImage.js';
import NwpLayerRenderer from './NwpImageLayerRenderer.js';
/**
 * @classdesc
 * Layer for rendering vector data as a heatmap.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @fires import("../render/Event.js").RenderEvent
 * @api
 */
var NwpImageLayer = /** @class */ (function (_super) {
    __extends(NwpImageLayer, _super);
    /**
     * @param {import("./BaseImage.js").Options=} opt_options Layer options.
     */
    function NwpImageLayer(opt_options) {
        var _this = _super.call(this, opt_options) || this;
        _this.left_ = opt_options.extent[0];
        _this.bottom_ = opt_options.extent[1];
        _this.right_ = opt_options.extent[2];
        _this.top_ = opt_options.extent[3];
        _this.width_ = opt_options.width;
        _this.height_ = opt_options.height;
        _this.palette_ = _this.makePalette(opt_options.palettes);
        _this.mask_ = opt_options.mask;
        return _this;
    }
    NwpImageLayer.prototype.getLeft = function () {
        return this.left_;
    };
    NwpImageLayer.prototype.getBottom = function () {
        return this.bottom_;
    };
    NwpImageLayer.prototype.getRight = function () {
        return this.right_;
    };
    NwpImageLayer.prototype.getTop = function () {
        return this.top_;
    };
    NwpImageLayer.prototype.getHeight = function () {
        return this.height_;
    };
    NwpImageLayer.prototype.getWidth = function () {
        return this.width_;
    };
    NwpImageLayer.prototype.getMask = function () {
        return this.mask_ ? this.mask_ : null;
    };
    NwpImageLayer.prototype.makePalette = function (palettes) {
        var indent = "\t\t\t";
        var str = "\t\tvec4 getColors(float v);\n\t\tvec4 getColors(float v) {  \n" + indent;
        var length = palettes.length;
        for (var i = 0; i < length; i++) {
            var p = palettes[i];
            var red = p.red == 0 ? "0.0" : p.red == 255 ? "1.0" : p.red.toFixed(1) + " / 255.0";
            var green = p.green == 0 ? "0.0" : p.green == 255 ? "1.0" : p.green.toFixed(1) + " / 255.0";
            var blue = p.blue == 0 ? "0.0" : p.blue == 255 ? "1.0" : p.blue.toFixed(1) + " / 255.0";
            var alpha = p.alpha == 0 ? "0.0" : p.alpha == 255 ? "1.0" : p.alpha.toFixed(1) + " / 255.0";
            // console.log(` key =  ${p.value}, red =  ${red}, green =  ${green}, blue =  ${blue}, alpha =  ${alpha}`);
            var ret = p.alpha == 0 ? "discard;" : "return vec4(" + red + ", " + green + ", " + blue + ", " + alpha + ");";
            if (i != (length - 1)) {
                str += (i == 0 ? "if " : " else if ") + " (v <= " + p.value.toFixed(1) + ") {\n" + indent + "  " + ret + "\n" + indent + "}";
            }
            else {
                str += " else {\n" + indent + " " + ret + "\n" + indent + "}";
            }
        }
        str += "\n\t\t}";
        return str;
    };
    /**
     * Create a renderer for this layer.
     * @return {WindyLayerRenderer} A layer renderer.
     */
    NwpImageLayer.prototype.createRenderer = function () {
        var this_ = this;
        return new NwpLayerRenderer(this, {
            vertexShader: "\n        precision highp float;\n        \n        uniform mat4 u_projectionMatrix;\n        uniform float u_resolution;\n\n        attribute vec2 a_position;\n        attribute float a_value;\n        attribute float a_show;\n        \n        varying float v_show;\n        varying float v_value;\n      \n        void main() {\n            v_show = a_show;\n            v_value = a_value;\n            gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0);\n        }",
            fragmentShader: "\n        precision highp float;\n\n        uniform float u_c_time;\n        uniform float u_resolution;\n        uniform vec4 u_color;\n       \n        varying float v_value;\n        varying float v_show;\n        \n" + this_.palette_ + "\n\n        void main() {\n            // float color = v_value * ALPHA;\n            if (v_show < 1.0) {\n                discard;\n            }\n            gl_FragColor = getColors(v_value); \n        }",
            uniforms: {
                u_color: [1.0, 1.0, 0.0, 0.1],
                u_c_time: function () {
                    // console.log(` u_c_time = ${performance.now()}`)
                    return performance.now() / 1000.0;
                },
            },
        });
    };
    return NwpImageLayer;
}(BaseImageLayer));
export default NwpImageLayer;
//# sourceMappingURL=NwpImageLayer.js.map